const IS_DEV = !process.env.NODE_ENV || process.env.NODE_ENV === "development";
// const IS_DEV = false

export default IS_DEV ? "staging" : "production";
